import { useState } from "react";
import { api } from "../api.js";
import { fmt } from "../i18n.js";
import { Loader, useLoad } from "../ui.jsx";

const ORDER = ["punctuality", "quality", "documentation", "workload"];

function prevMonths(n = 12) {
  const out = [];
  const d = new Date(Date.now() + 2 * 36e5);
  for (let i = 0; i < n; i++) {
    const m = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() - i, 1));
    out.push(m.toISOString().slice(0, 7));
  }
  return out;
}
const monthName = (m) => new Intl.DateTimeFormat("ar-LY", { month: "long", year: "numeric", numberingSystem: "latn" })
  .format(new Date(m + "-15T00:00:00Z"));

export function MyEvaluation({ userId, month: initial }) {
  const [month, setMonth] = useState(initial || prevMonths(1)[0]);
  const state = useLoad(() => api.get((userId ? `/kpi/users/${userId}` : "/kpi/me") + `?month=${month}`), [userId, month]);
  return (
    <div className="page">
      <header className="page-head">
        <h1>{userId ? "تقييم موظف" : "تقييمي"}</h1>
        <select value={month} onChange={(e) => setMonth(e.target.value)} aria-label="الشهر">
          {prevMonths().map((m) => <option key={m} value={m}>{monthName(m)}</option>)}
        </select>
      </header>
      <Loader state={state}>{(ev) => (
        <>
          <section className="panel eval-head">
            <div className="eval-score">
              {ev.sufficient ? <><b>{fmt.num(ev.overall, 1)}</b><span>من 100</span></> : <b className="eval-none">لا توجد بيانات كافية</b>}
            </div>
            <div>
              <h2>{ev.user.name} — {monthName(ev.period.month)}</h2>
              <p className="muted">{ev.period.provisional ? "نتيجة مبدئية تتحدث حتى إغلاق الشهر." : "نتيجة نهائية لشهر مغلق."}
                {ev.scope === "projects" && " النطاق: المهام في مشاريعك فقط."}</p>
              <p className="muted small">{ev.note}</p>
            </div>
          </section>
          <div className="eval-grid">{ORDER.map((k) => {
            const c = ev.components[k];
            return (
              <section className="panel eval-comp" key={k}>
                <header><h3>{c.label}</h3><span className="muted">الوزن {c.weight}%{c.effective_weight != null && c.effective_weight !== c.weight ? ` (فعلي ${c.effective_weight}%)` : ""}</span></header>
                <div className="eval-bar"><div style={{ inlineSize: (c.score ?? 0) + "%" }} /></div>
                <b className="eval-val">{c.score == null ? "لا توجد بيانات" : fmt.num(c.score, 1)}</b>
                <p className="small muted">{c.method}</p>
                <p className="small">عدد المهام: {c.task_count}</p>
              </section>
            );
          })}</div>
          {ev.redistributed && <p className="callout">بعض المكونات بلا بيانات هذا الشهر، فوُزّع وزنها على المكونات المتاحة.</p>}
          <section className="panel">
            <h2>المهام التي دخلت في الحساب</h2>
            {ev.tasks.length === 0 ? <p className="muted">لا توجد مهام في هذه الفترة.</p> : (
              <div className="table-wrap"><table className="table">
                <thead><tr><th>المهمة</th><th>الوزن</th><th>الموعد المعدّل</th><th>الإرسال المقبول</th><th>تأخير (س)</th>
                  <th>الالتزام</th><th>الجودة</th><th>التوثيق</th><th>حجم العمل</th></tr></thead>
                <tbody>{ev.tasks.map((x) => (
                  <tr key={x.task_id}>
                    <td><a href={`#/tasks/${x.task_id}`}>{x.ref} {x.title}</a><br /><small className="muted">{x.project_name}{x.share_pct !== 100 ? ` — حصتك ${x.share_pct}%` : ""}</small></td>
                    <td>{x.weight}</td>
                    <td>{fmt.dt(x.adjusted_due_at)}{x.excluded_hours ? <small className="muted"><br />+{x.excluded_hours} س عوائق</small> : null}</td>
                    <td>{fmt.dt(x.accepted_submitted_at)}</td>
                    <td>{x.late_hours ?? "—"}</td>
                    <td>{x.punctuality ?? "—"}</td>
                    <td>{x.quality ?? "—"}{x.execution_error_returns ? <small className="muted"><br />{x.execution_error_returns} إعادة تنفيذية</small> : null}</td>
                    <td>{x.documentation ?? "—"}</td>
                    <td>{x.counted_for_workload ? (x.completed_by_period_end ? "منجزة" : "مستحقة غير منجزة") : "—"}</td>
                  </tr>))}</tbody>
              </table></div>
            )}
            <p className="small muted">حجم العمل: منجز {ev.workload.completed_weight} من وزن مستحق {ev.workload.due_weight}. المهام الملغاة لا تدخل في الحساب.</p>
          </section>
        </>
      )}</Loader>
    </div>
  );
}
